import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({message = "Chargement des données..."}) => {
    return (
        <div className="premium-loader-container">
            <div className="premium-loader">
                <div className="spinner-ring"></div>
                <div className="spinner-dot"></div>
                <div className="loading-message">
                    {message}
                    <div className="dots-container">
                        <span></span><span></span><span></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
